export default __webpack_public_path__ + "static/media/ghost.7ffcee87.png";